import React, { useEffect, useState } from "react";
import axios from "axios";

const instaAccessToken = process.env.REACT_APP_INSTA_ACCESS_TOKEN;

const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        const response = await axios.get(
          `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink&access_token=${instaAccessToken}`,
        );
        setPosts(response.data.data);
      } catch (error) {
        console.error("Ошибка при получении данных из Instagram:", error);
      }
    };

    fetchInstagramPosts();
  }, []);

  return (
    <div>
      {posts.map(post => (
        <div key={post.id}>
          {post.media_type === "IMAGE" && (
            <img src={post.media_url} alt={post.caption} />
          )}
          {post.media_type === "VIDEO" && (
            <video controls>
              <source src={post.media_url} type="video/mp4" />
            </video>
          )}
          <p>{post.caption}</p>
          <a href={post.permalink} target="_blank" rel="noopener noreferrer">
            Смотреть в Instagram
          </a>
        </div>
      ))}
    </div>
  );
};

export default InstagramFeed;
